export default __webpack_public_path__ + "49f000aadd46397025bf4e3ee109639f.svg";